import { ReactNode } from "react";
import { ToastAria } from "@react-aria/toast";

import Typography from "../../Typography";
import styles from "./styles.module.css";

type ToastHeaderProps = {
  children: ReactNode;
  ariaProps?: ToastAria["descriptionProps"];
  maxLines?: number;
};

const ToastDescription = ({ children, ariaProps, maxLines = 20 }: ToastHeaderProps) => {
  return (
    <Typography
      {...ariaProps}
      tag="p"
      className={styles.description}
      style={{ WebkitLineClamp: maxLines }}
    >
      {children}
    </Typography>
  );
};

ToastDescription.displayName = "DS.Toast.Description";

export default ToastDescription;
